export default __webpack_public_path__ + "locales/fi/PaymentsEnterprise.json?hash=80d40eb1a9008194a96c32c3c482ac8d";